import { createFileRoute } from '@tanstack/react-router';
import { InboxList } from '@/components/InboxList';

export const Route = createFileRoute('/_auth/inbox/archive')({
  component: ArchivedInboxRoute,
});

function ArchivedInboxRoute() {
  return <InboxList archived />;
}
